<div class="indicator" id="indicator" [dir]="data.dir">
    <formio-loader></formio-loader>
    <br />
    <br />
    <div class="container">
        <div class="add-new" setRtl>
            <ng-container *ngIf="data.isSummary;else details">
                <lib-section
                    [title]="('forms.common.indicatorSummary' | translate) + ' - ' + ('forms.common.' + data.indicator.key | translate)">
                </lib-section>
            </ng-container>
            <ng-template #details>
                <lib-section [title]="'forms.common.' + data.indicator.key | translate"></lib-section>
            </ng-template>

            <mat-expansion-panel *ngFor="let domain of this.data.indicator.domains;let domainIndex = index" #expansion>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="title-container">
                            <div>{{domain.domainNumber }} <span class="separator"></span> {{'forms.common.' +
                                domain.key | translate}}</div>
                            <app-indicator-status class="status" [status]="domain.decision"></app-indicator-status>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <p>{{'forms.common.' + domain.description | translate}}</p>
                <br />

                <ng-container *ngIf="!data.options.hideQuestions && !data.isSummary">
                    <div>
                        <ng-container *ngFor="let question of domain.questions">
                            <app-indicator-question [question]="question" [dir]="data.dir"
                                [viewOnly]="data.options.disableQuestions || domain.decision == indicatorStatus.Completed">
                            </app-indicator-question>
                            <br />
                        </ng-container>
                    </div>
                    <br />
                </ng-container>

                <ng-container *ngIf="!data.options.hideAttachments && !data.isSummary && ready">
                    <div class="card">
                        <h6>{{'forms.common.Attachments' | translate}}</h6>
                        <formio #forms [id]="domain.id"
                            [submission]="{data:{attachments : domain.attachmentsInstance }}"
                            [formKey]="data.indicator.attachmentsFormKey" [showLoader]="false"
                            (formLoad)="formLoad($event)"
                            [readOnly]="data.options.disableAttachments || domain.decision == indicatorStatus.Completed"
                            [viewOnly]="data.options.disableAttachments || domain.decision == indicatorStatus.Completed">
                        </formio>
                    </div>
                    <br />
                </ng-container>
                <div>
                    <div class="wrapFlex" *ngIf="!data.options.hideNotes && !data.isSummary">
                        <div class="avatar userAvatar" title="{{'forms.common.Notes' | translate}}"></div>
                        <div class="notesContainer notes m-start" [dir]="data.dir">
                            <div class="box sb1">
                                <textarea class="form-control m-b-5" [(ngModel)]="domain.notes"
                                    [disabled]="data.options.disableNotes || data.isSummary"
                                    placeholder="{{'forms.common.Notes' | translate}}"></textarea>
                            </div>
                            <mat-error
                                *ngIf="domainsDecisions[domainIndex] == indicatorStatus.NotComplete && !domain.notes">
                                {{'forms.common.It can not be empty' | translate}}
                            </mat-error>
                        </div>
                    </div>
                    <br />
                    <div class="wrapFlex wrapFlexReverse" *ngIf="!data.options.hideRecommendations">
                        <div class="avatar smallLogo"
                            title="{{'forms.common.detective notes & recommendations' | translate}}">
                        </div>
                        <div class="notesContainer recommendations m-end">
                            <div class="box sb1">
                                <textarea class="form-control m-b-5" [(ngModel)]="domain.recommendations"
                                    [required]="domain.decision == indicatorStatus.NotComplete"
                                    [disabled]="data.options.disableRecommendations || data.isSummary"
                                    placeholder="{{'forms.common.detective notes & recommendations' | translate}}"></textarea>
                            </div>
                            <mat-error
                                *ngIf="domainsDecisions[domainIndex] == indicatorStatus.NotComplete && !domain.recommendations">
                                {{'forms.common.It can not be empty' | translate}}
                            </mat-error>
                        </div>
                    </div>
                </div>
                <br />

                <ng-container *ngIf="!data.options.hideDecision">
                    <div class="card">
                        <label class="m-b-5">{{'forms.common.domainDecision' | translate}}</label>
                        <div class="radioContainer">
                            <div class="content">
                                <input class="radio" type="radio" [value]="indicatorStatus.NotComplete"
                                    [(ngModel)]="domainsDecisions[domainIndex]"
                                    name="decision_{{domain.id}}_notComplete"
                                    [disabled]="data.options.disableDecision || data.isSummary">
                                <label for="no">{{'forms.common.no' | translate}}</label>
                            </div>
                            <div class="content">
                                <input class="radio" type="radio" [value]="indicatorStatus.Completed"
                                    [(ngModel)]="domainsDecisions[domainIndex]" name="decision_{{domain.id}}_completed"
                                    [disabled]="data.options.disableDecision || data.isSummary">
                                <label for="no">{{'forms.common.yes' | translate}}</label>
                            </div>
                        </div>
                    </div>
                    <br />
                </ng-container>

                <div style="text-align: end;"
                    *ngIf="!data.options.hideSaveDomain && !data.isSummary && (!data.options.hideDecision||(data.options.hideDecision && domainsDecisions[domainIndex] != indicatorStatus.Completed))">
                    <button class="dialog-button dialog-save" (click)="save(domainIndex,expansion);"
                        [disabled]="domainsDecisions[domainIndex] == indicatorStatus.NotComplete && (!domain.recommendations || !domain.notes)">
                        {{'forms.common.save' | translate}}
                    </button>
                </div>

                <br />
            </mat-expansion-panel>

            <br />
            <br />
            <div [style.textAlign]="data.isSummary ? 'center' : 'end'">
                <button class="dialog-button dialog-cancel" (click)="close()">
                    {{'forms.common.back' | translate}}
                </button>

                <ng-container *ngIf="data.isSummary && !data.options.hideSaveDomain">
                    <button class="dialog-button dialog-save" (click)="updateDomains(true)">
                        {{'forms.common.updateAllDomains' | translate}}
                    </button>
                    <button class="dialog-button dialog-update" (click)="updateDomains()">
                        {{'forms.common.updateNotCompletedDomains' | translate}}
                    </button>
                </ng-container>

            </div>
        </div>
    </div>
    <br />
    <br />
</div>